import {createContext} from 'react';

const ProviderContext = createContext(null);

export {
    ProviderContext
};
